// removed by extract-text-webpack-plugin
module.exports = {"custom":"Button__custom___1XBBl","link":"Button__link___2cbYX"};